module.exports = __webpack_public_path__ + "static/media/_british-columbia.83a8b582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_british-columbia.svg
// module id = 2306
// module chunks = 7